'use client';
import { rem } from '@s7/styles';

var COMPONENT_ID = "ButtonTypography";
var sizes = {
    normal: rem(16),
    small: rem(14)
};
var heights = {
    normal: rem(24),
    small: rem(20)
};
var BUTTON_TYPOGRAPHY_SIZES = {
    lg1: sizes.normal,
    md1: sizes.normal,
    sm1: sizes.small,
    xs1: sizes.small
};
var BUTTON_TYPOGRAPHY_HEIGHTS = {
    lg1: heights.normal,
    md1: heights.normal,
    sm1: heights.small,
    xs1: heights.small
};
var defaultButtonTypographyProps = {
    sizes: BUTTON_TYPOGRAPHY_SIZES,
    heights: BUTTON_TYPOGRAPHY_HEIGHTS,
    weight: 500
};

export { BUTTON_TYPOGRAPHY_HEIGHTS, BUTTON_TYPOGRAPHY_SIZES, COMPONENT_ID, defaultButtonTypographyProps };
